export default __webpack_public_path__ + "static/media/navInbox.9a6c9f01.svg";